import cs from 'classnames';
import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import { generateFieldClassNames } from '@/DesignSystem/Helper';
import type { IFieldProps } from '@/DesignSystem/Model/DataModel';
interface ITextAreaProps extends IFieldProps {
  rows?: number;
  placeholder?: string;
}
const TextArea: FC<ITextAreaProps> = props => {
  const {
    control,
    name,
    defaultValue,
    prefix,
    suffix,
    rows,
    label,
    placeholder
  } = props;
  return <Controller name={name} control={control} defaultValue={defaultValue ?? ''} render={({
    field,
    fieldState
  }) => {
    const error = fieldState.error?.message || '';
    return <div className={generateFieldClassNames({
      ...props,
      hasError: !!error,
      hasValue: field.value !== undefined && field.value !== null && String(field.value).length > 0
    })}>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label>
              {label && <div className={cs('ui__field__label', `${prefix || suffix ? 'right-14' : 'right-4'}`)}>{label}</div>}
              <div className="ui__field__content">
                {prefix && <div className="ui__field__prefix">{prefix}</div>}
                <textarea className="ui__field__element ui__field--type-input" rows={rows} placeholder={placeholder} {...field} />
                {suffix && <div className="ui__field__suffix">{suffix}</div>}
              </div>
            </label>
          </div>;
  }} data-sentry-element="Controller" data-sentry-component="TextArea" data-sentry-source-file="TextArea.tsx" />;
};
TextArea.defaultProps = {
  rows: 3,
  size: 'middle'
};
export default TextArea;